<template>
  <div class="d-flex align-center">
    <p class="flex-shrink-0">สิ้นสุดเวลา</p>
    <p class="flex-grow-1">{{ publishDate | moment("DD MMM YYYY HH:mm") | toTh }}</p>
  </div>
</template>

<script>
export default {
  data: () => ({
    countdown: "",
    publishDate: "",
    timerId: null,
    state: {
      normal: {
        color: "green"
      },
      near: {
        left: 10,
        color: "orange darken-2"
      },
      almost: {
        left: 3,
        color: "red darken-1"
      }
    },
    barColor: "green"
  }),
  filters: {
    toTh: function (value) {
      if (!value) return ''
      value = value.toString()
      let monthTh =  {"Jan": "มกราคม", "Feb": "กุมภาพันธ์", "Mar":"มีนาคม", "Apr":"เมษายน", "May":"พฤษภาคม", "Jun":"มิถุนายน",
        "Jul":"กรกฎาคม", "Aug":"สิงหาคม", "Sep":"กันยายน", "Oct":"ตุลาคม", "Nov":"พฤศจิกายน", "Dec":"ธันวาคม"}
      let getMonth = value.substring(3,6)
      let convertMonth = value.replace(getMonth, monthTh[getMonth])
      console.log(`${convertMonth} น.`)
      return `${convertMonth} น.`
    }
  },
  methods: {
    onExpire() {
      this.$emit("expire","publishDate");
    },
    startTimerOld(config) {
      this.cancelTimer();
      console.log(config)
      const endTime = this.$moment(config.endPublished);
      const currTime = this.$moment(config.startPublished);
      this.publishDate = config.endPublished
      let duration = this.$moment.duration(
        endTime.diff(currTime),
        "milliseconds"
      );
      let interval = 1000;

      this.timerId = setInterval(() => {
        duration = this.$moment.duration(duration - interval, "milliseconds");
        let hrs = duration.hours();
        let min = duration.minutes();
        let sec = duration.seconds();
        // if (hrs > 0) {
        //   min += hrs * 60;
        // }
        if (config.endPublished !== 0 && hrs == 0 && min == 0 && sec <= 0) {
          this.onExpire();
        } else {
          // this.countdown = `${hrs
          //   .toString()
          //   .padStart(2, "0")} : ${min
          //   .toString()
          //   .padStart(2, "0")} : ${sec.toString().padStart(2, "0")}`;

          // color state
          if (hrs == 0) {
            if (min < this.state.almost.left) {
              this.barColor = this.state.almost.color;
            } else if (min < this.state.near.left) {
              this.barColor = this.state.near.color;
            }
          }
        }
      }, interval);
    },
    startTimer(config) {
      this.cancelTimer();

      let interval = 1000;
      let duration = config.endPublished - config.currtime
      this.publishDate = config.endPublished
      this.timerId = setInterval(() => {
        duration = duration - interval;
        let days = Math.floor(duration / (1000 * 60 * 60 * 24));
        // let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let hours = Math.floor((duration) / (1000 * 60 * 60));
        let minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((duration % (1000 * 60)) / 1000);
        if (config.endPublished !== 0 && duration < 0) {
          this.onExpire();
        } else {
          if (hours == 0) {
            if (minutes < this.state.almost.left) {
              this.barColor = this.state.almost.color;
            } else if (minutes < this.state.near.left) {
              this.barColor = this.state.near.color;
            }
          }
        }
      }, interval);
    },
    cancelTimer() {
      this.barColor = this.state.normal.color;

      if (this.timerId != null) {
        clearInterval(this.timerId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p { 
  margin: 0; font-size: 1rem;

  &:nth-of-type(01) { color: #737e8a; margin-right: 8px; } 
} 
</style>